// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-settings-tab-organization-UsersCard-module__root--1P612","email":"src-components-page-settings-tab-organization-UsersCard-module__email--sZfe3"};